export default [
  {
    path: '/node-equipment',
    name: 'NodeDevice',
    component: resolve => require(['@/views/NodeDevice'], resolve)
  }
]
